import {Editor} from "./Editor.js";
import {SelectEditor} from "./SelectEditor.js";
import {msg} from "@/i18n/Message.ts";

export class FormPartEditor extends Editor {
	constructor(parentEditor, fieldPath, obj, member) {
		super(parentEditor, fieldPath, obj, member);
	}


	rebuild() {
		this.root = $('<div class="fpart"></div>');
		const d = this.data;

		const icnUrl = FormPartEditor.icnForType(d.type);
		const icn = $(Icon.fi(icnUrl, "fpart-icn"));
		this.root.append(icn);

		const label = $('<div class="fpart-label"></div>');
		if (d.label) label.text(d.label);
		else {
			if (d.name) label.text(d.name);
			else label.text(d.type);
		}
		this.root.append(label);

		const vis = $('<div class="fpart-visiblity"></div>');
		let sel = new SelectEditor(this, "visibility", d, "visibility", {
			items: [
				{ value: 'HIDDEN', name: msg('visibility.hidden') },
				{ value: 'DEFAULT', name: msg('visibility.default') },
				{ value: 'VISIBLE', name: msg('visibility.visible') }
			]
		});
		this.addChildEditor(sel);
		this.root.append(sel.ui);
	}

	/*
	FORM("F"),
	BODY("form-body"), FLOW("flow"), ARRAY("[]"),
	STRING("S"), INT("I"), BOOL("B"), TEMPORAL("D"), LABEL("L"), EADDRESS("eaddress"), ADDRESS("address"), SET("M"), BLOCK("block"),
	USER("U"), INFO("info"), SPAN("span"), HTML("html"), PARTY("P"), RICH_TEXT("RT");
	 */
	static icnForType(type) {
		let i = "attr-text";
		switch (type) {
			case "S": i = "attr-text";break;
			case "I": i = "attr-int";break;
			case "B": i = "attr-boolean";break;
			case "D": i = "attr-time";break;
			case "L": i = "attr-title";break;
			case "eaddress": i = "attr-text";break;
			case "address": i = "attr-text";break;
			case "M": i = "attr-set";break;
			case "block": i = "attr-html";break;
			case "U": i = "attr-user";break;
			case "info":i = "attr-html";break;
			case "span":i = "attr-html";break;
			case "html":i = "attr-html";break;
			case "title":i = "attr-title";break;
			case "P": i = "attr-party";break;
			case "RT":i = "attr-rich-text";break;
		}
		return i;
	}
}